import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';

@Component({
    selector: 'app-edit-transaction',
    templateUrl: './edit-transaction.component.html',
    styleUrls: ['./edit-transaction.component.scss'],
    standalone: false
})
export class EditTransactionComponent {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  sharedService = inject(SharedService);

  @Input() amount: number;
  @Input() remark;
  @Input() transactionId: number;

  @Output() passEntry = new EventEmitter<any>();

  updateTransactionAmountAndRemark() {
    const data = {
      "amount": this.amount,
      "remark": this.remark
    };

    const xhr = this.restapi.patchRequest(this.constructApi.getATransactionByID(Number(this.transactionId)), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);
        //if success emit
        this.passEntry.emit();
        this.reset();
        this.sharedService.openAlert("Successfully updated transaction", ALERT_TYPE.SUCCESS)
      }
    }
  }

  confirmBeforeUpdate() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to update transaction amount = RM " + this.amount + " and remark=" + this.remark + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.updateTransactionAmountAndRemark();
    });

    return proceed;
  }

  checkFieldNull() {
    const amountNull = this.amount == undefined;
    const amountValid = isNaN(+this.amount);
    const remarkNull = this.remark == undefined;

    return amountNull || amountValid || remarkNull;
  }

  reset() {
    this.activeModal.close();
  }
}
